import { render, staticRenderFns } from "../../templates/form/move-farm-form.pug?vue&type=template&id=73e991c0&lang=pug&"
import script from "./MoveFarmForm.vue?vue&type=script&lang=js&"
export * from "./MoveFarmForm.vue?vue&type=script&lang=js&"
import style0 from "./MoveFarmForm.vue?vue&type=style&index=0&id=73e991c0&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports